function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import compose from '../../../utils/compose';
import { SimpleGroupTitleField, wrapGroupTemplate } from '../../GroupTemplate/SimpleGroupTemplate';
import GroupGridGroupsProvider, { GroupGridGroupsContext } from '../../GroupTemplate/GroupGridGroupsContext';
import { AccordionGroupTitleField } from '../../GroupTemplate/AccordionGroupTemplate';
import RecordEditorUseAccordionContext from '../RecordEditorUseAccordionContext';
import withStaticTextPruning from './withStaticTextPruning';
import ThemeContext from '../../../ThemeContext/ThemeContext';
function BaseRecordEditorGroupTemplate(props) {
  var gridGroups = useContext(GroupGridGroupsContext);
  var theme = useContext(ThemeContext);
  var formContext = props.formContext;
  var dmLayout = formContext.uiSchema['dm:layout'] || [];
  var isTopLevel = Array.isArray(dmLayout) ? dmLayout.find(function (element) {
    return element.id === props.id;
  }) !== undefined : true;
  var isSmallGridGroup = gridGroups.length === 1 && gridGroups[0].useGrid && gridGroups[0].children.length <= 4;
  var isCollapsible = formContext.isPrintView || formContext.isCardView ? false : isTopLevel && !isSmallGridGroup && theme !== 'dm';
  var groupComponent = isCollapsible ? /*#__PURE__*/React.createElement(AccordionGroupTitleField, props) : /*#__PURE__*/React.createElement(SimpleGroupTitleField, props);
  return /*#__PURE__*/React.createElement(RecordEditorUseAccordionContext.Provider, {
    value: isCollapsible
  }, groupComponent);
}
function RecordEditorGroupTemplate(props) {
  var children = props.children,
    rest = _objectWithoutProperties(props, ["children"]);
  var isCardView = props.formContext.isCardView;
  return /*#__PURE__*/React.createElement(GroupGridGroupsProvider, {
    groupChildren: children,
    isCardView: isCardView
  }, /*#__PURE__*/React.createElement(BaseRecordEditorGroupTemplate, Object.assign({
    groupChildren: children
  }, rest)));
}
export default compose(withStaticTextPruning, wrapGroupTemplate)(RecordEditorGroupTemplate);